import { Dialog, DialogTitle } from "@mui/material";
import { styled } from "@mui/material/styles";

const CustomDialog = styled(Dialog)(({ theme }) => ({
    "& .MuiPaper-root": {
        borderRadius: 0,
        backgroundColor: "var(--white)",
        width: "100%",
        height: "calc(100% - 40px)",
        maxWidth: "none",
        maxHeight: "none",
        margin: 20,
        boxShadow: "none"
    },
    "& .MuiBackdrop-root": {
        backgroundColor: "rgba(0, 0, 0, 0.40)"
    },
    zIndex: 99,
    position: "absolute"
}));



export function Popup({ mobilePopup, setMobilePopup, children, id, title }) {
    return (
        <CustomDialog
            onClose={() => setMobilePopup(null)}
            open={mobilePopup === id}
        >
            <div onClick={() => setMobilePopup(null)} className="bigX"></div>
            <h2 style={{ padding: "0 20px", height: "56px", fontSize: "20px", lineHeight: "75px" }}>{title}</h2>
            <div style={{ padding: "20px", flex: 1, overflowY: "auto" }}>
                {children}
            </div>
        </CustomDialog>
    )
}

const CustomDialogIframe = styled(Dialog)(({ theme }) => ({
    "& .MuiPaper-root": {
        borderRadius: 0,
        backgroundColor: "var(--white)",
        height: "calc(100vh - 150px)",
        width: "calc(100vh - 150px)",
        maxWidth: "100%",
        margin: 20,
    },
    "& .MuiBackdrop-root": {
        backgroundColor: "rgba(0, 0, 0, 0.40)"
    },
    zIndex: 99,
    position: "absolute"
}));
export function PopupIframe({ mobilePopup, setMobilePopup, children }) {
    return (
        <CustomDialogIframe
            onClose={() => setMobilePopup()}
            open={mobilePopup}
        >
            <div onClick={() => setMobilePopup()} className="bigX"></div>
            {children}
        </CustomDialogIframe>
    )
}